import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-292ef7af"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "head-top"
};
const _hoisted_2 = {
  key: 0,
  class: "head-logo"
};
const _hoisted_3 = {
  href: "index.html"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "head-infor"
};
const _hoisted_6 = {
  key: 0,
  class: "head-login"
};
const _hoisted_7 = ["href"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-xingzhuang"
}, null, -1));
const _hoisted_9 = {
  class: "el-dropdown-link"
};
const _hoisted_10 = {
  class: "user-info"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "user-name"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  underline: false,
  target: "_self"
}, "退出", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search = _resolveComponent("search");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_arrow_down = _resolveComponent("arrow-down");
  const _component_el_link = _resolveComponent("el-link");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  return _openBlock(), _createElementBlock("div", {
    class: "header",
    style: _normalizeStyle({
      'background-image': `url(${_ctx.projectInfo.home_head_bg_url || '//image.zhihuishu.com/zhs/ablecommons/zhangying/202104/5c054f3a7c804fc5829b114cc174c17d.png'})`
    })
  }, [_createElementVNode("div", _hoisted_1, [_ctx.projectInfo.home_logo_url ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("a", _hoisted_3, [_createElementVNode("img", {
    class: "school-img",
    src: _ctx.projectInfo.home_logo_url,
    alt: ""
  }, null, 8, _hoisted_4)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
    class: "search-input",
    modelValue: _ctx.searchKey,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.searchKey = $event),
    placeholder: "输入课程或案例名称搜索",
    onKeyup: _withKeys(_ctx.search, ["enter"])
  }, {
    suffix: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "icon-seach el-input__icon",
      onClick: _ctx.search
    }, {
      default: _withCtx(() => [_createVNode(_component_search)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }, 8, ["modelValue", "onKeyup"]), _createVNode(_component_el_button, {
    type: "primary",
    class: "my-case-btn",
    onClick: _ctx.gotoMyCase
  }, {
    default: _withCtx(() => [_createTextVNode("我的案例")]),
    _: 1
  }, 8, ["onClick"]), !_ctx.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("a", {
    href: _ctx.loginUrl
  }, [_hoisted_8, _createTextVNode(" 登录 ")], 8, _hoisted_7)])) : (_openBlock(), _createBlock(_component_el_dropdown, {
    key: 1,
    class: "head-user"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_ctx.userInfo.roleId ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_link, {
          underline: false,
          target: "_blank",
          href: "/admin/"
        }, {
          default: _withCtx(() => [_createTextVNode("管理后台")]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_dropdown_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_link, {
          underline: false,
          href: `/setting.html`
        }, {
          default: _withCtx(() => [_createTextVNode("账号设置")]),
          _: 1
        }, 8, ["href"])]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        onClick: _ctx.logout
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("span", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
      class: "avatar",
      src: _ctx.userInfo.avatar ? _ctx.$fileHost + _ctx.userInfo.avatar : require('@/assets/images/user_icon.png')
    }, null, 8, _hoisted_11), _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.userInfo.realname), 1)]), _createVNode(_component_el_icon, {
      class: "el-icon--right toggle-arrow-span"
    }, {
      default: _withCtx(() => [_createVNode(_component_arrow_down)]),
      _: 1
    })])]),
    _: 1
  }))])])], 4);
}